import Ruble from '../../svg/Ruble';
import Calendar from '../../svg/Calendar';

import './CreditInfo.css';

export default function CreditInfo({ creditData }) {
  const getDays = () => {
    const days = +creditData?.overdueDebitDelayValue;
    if (days % 10 === 1) {
      return `${days} день`;
    } else if (days % 10 >= 2 && days % 10 <= 4) {
      return `${days} дня`;
    } else {
      return `${days || 0} дней`;
    }
  };

  return (
    <div className='credit-info'>
      {creditData?.overdueDebitValue ? (
        <div className='arrears'>
          <span>Просрочка</span>
          <div className='arrears-info'>
            <div className='icon-num'>
              <Ruble />
              <span>
                {creditData?.overdueDebitValue?.toLocaleString('ru') || 0}
              </span>
            </div>
            <div className='icon-num'>
              <Calendar />
              <span>{getDays()}</span>
            </div>
          </div>
        </div>
      ) : null}
      <div className='credit-main-info'>
        <div className='credit-block'>
          <span>Задолженность</span>
          <div className='icon-num'>
            <Ruble />
            <span>{creditData?.debitValue?.toLocaleString('ru') || 0}</span>
          </div>
        </div>
        <div className='credit-block'>
          <span>Общий лимит</span>
          <div className='icon-num'>
            <Ruble />
            <span>{creditData?.limitValue?.toLocaleString('ru') || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
